<section class="cards-carousel">
  <div class="cards-carousel__cards">
    <div class="cards-carousel__cards-container" #scrollContainer>
      <div class="cards-carousel__cards-layout">
        <div class="cards-carousel__cards-dummy-item"></div>
        @for (item of items; track item.id) {
          <article class="cards-carousel__cards-item" #containerItem>
            <ng-template [paiInsertDynamicCard]="item" />
          </article>
        }
        <div class="cards-carousel__cards-dummy-item"></div>
      </div>
    </div>
  </div>

  @if (pages$ | async; as pages) {
    @if (pages.length > 1) {
      <div class="cards-carousel__pagination">
        @for (d of pages; track d) {
          <button
            #navDot
            (click)="scrollToPage(d)"
            class="cards-carousel__pagination-dot"
            type="button"
            cdkMonitorElementFocus
            [attr.aria-label]="'Carousel.ShowPage' | translate: { ix: d + 1 }"
            paiRipple
          >
            <span></span>
          </button>
        }
      </div>
    }
  }
</section>
